export const FONTCOLOR_KEY = 'fontColor'
